import Model from "~/models/_Model";

export default class ApRecommendation extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "ap-recommendations";
  }

  relations() {
    return {};
  }

  // Computed Attributes
}
